module.exports = "/images/vendor/flag-icon-css/flags/4x3/sm.svg?3b1c9fb5c651a0bda66739b990a1456d";